import api from '../../plugins/api';

const getServiceRecords = (params) => {
  return api.get('/api/crm/services/getServiceRecords', params);
};

export default getServiceRecords;
